




















































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { Form as ElForm } from 'element-ui'
import { phoneNumberValidator, passwordValidator, usernameValidator, checkPasswordValidator } from '../../utils/validator'
import { generateCountDown } from '../../utils/timeUtils'
import api from '../../api'
import Jsencrypt from 'jsencrypt'
import { formatDate } from '../../utils/utils'

@Component
export default class ResetPassword extends Vue {
  private countDown = generateCountDown()
  private timeDown: number = 90
  private timeNum: number = 90
  private title: string = '找回密码'
  private pubKey: string = ''
  private isModify: boolean = false
  private loginForm = {
    username: '',
    password: '',
    checkpassword: '',
    code: '',
  }
  private loginRules = {
    username: [{ required: true, trigger: 'blur', validator: usernameValidator }],
    password: [{ required: true, trigger: 'blur', validator: passwordValidator }],
    checkpassword: [{ required: true, trigger: 'blur', validator: checkPasswordValidator(() => this.loginForm.password) }],
    code: [{ required: true, trigger: 'blur', message: '验证码不能为空' }],
  }
  private loading = false
  private pwdType = 'password'
  private redirect: string | undefined = undefined

  public mounted() {
    const { query = {} } = this.$route
    if (query.isModify) {
      this.isModify = true
      this.title = '修改密码'
    }
  }

  private handleSendCode() {
    (this.$refs.loginForm as ElForm).validateField('username', (valid) => {
      if (!valid) {
        api.sendPhoneCode({ name: this.loginForm.username }).then((pubKey: any) => {
          this.$message.success('发送成功')
          this.pubKey = pubKey
          this.countDown(this.timeNum).onUpdate((time) => { this.timeDown = time }).onComplete(() => {
            this.timeDown = this.timeNum
          })
        })
      }
    })
  }
  private showPwd() {
    if (this.pwdType === 'password') {
      this.pwdType = ''
    } else {
      this.pwdType = 'password'
    }
  }

  private handleLogin() {
    (this.$refs.loginForm as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.loading = true
        const { username, password, code } = this.loginForm
        let jse = new Jsencrypt()
        jse.setPublicKey(this.pubKey)
        api.modifyPassword({
          name: username,
          pwd: jse.encrypt(password),
          code,
        }).then(() => {
          this.$message.success('密码修改成功')
          this.$router.push({ name: 'Login' })
        }).finally(() => {
          this.loading = false
        })
      }
    })
  }
}
